module.exports = __webpack_public_path__ + "img/parasight_catalytic_spore.4a2c69bf.png";